import { TextDisclaimer } from './styles'

export const Disclaimer = ({ text }: { text: string }) => {
  return <TextDisclaimer>{text}</TextDisclaimer>
}
